export default __webpack_public_path__ + "static/media/navIcon.d1921c5b.png";